export default function AboutCountry({ data }) {

  const stripHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const popularStatesHTML = data.aboutCountry.popular_states;

  const popularStates = popularStatesHTML
    ? Array.from(
        new DOMParser()
          .parseFromString(popularStatesHTML, "text/html")
          .querySelectorAll("li")
      ).map((li) => li.textContent.trim())
    : [];

  return (
    <div className="space-y-6 font-inter">
      {/* ================= About Country ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" />{" "}
          About Canada
        </h3>

        <div className="grid grid-cols-2 gap-x-16 gap-y-5 text-[13px]">
          <Info label="Capital" value={data.aboutCountry.capital} />
          <Info label="Currency" value={data.aboutCountry.currency_code} />
          <Info label="INR Value" value={data.aboutCountry.inr_value} />
          <Info label="Language" value={data.aboutCountry.language} />
        </div>

        {/* Illustration */}
        <img
          src="/icons/grad-cap.svg"
          alt=""
          className="absolute right-6 top-8 w-24 opacity-80 pointer-events-none"
        />
      </div>

      {/* ================= Why Choose Australia ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" /> Why
          Choose Canada
        </h3>

        <p className="text-md text-gray-800 leading-relaxed max-w-4xl">
          {stripHtml(data?.aboutCountry?.about_country)}
        </p>

        <div className="absolute right-[-40px] top-[-40px] w-36 h-36 bg-orange-100 rounded-full opacity-40" />
      </div>

      {/* ================= Popular States ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" />{" "}
          Popular States
        </h3>

        <div className="flex gap-4 flex-wrap">
          {popularStates.map((state, index) => (
            <div
              key={index}
              className="flex items-center gap-2 px-4 py-2 border rounded-lg text-[12px] bg-gray-50"
            >
              <span className="text-gray-700">{state}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Education System ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" />{" "}
          Education System
        </h3>

        <table className="w-full text-[13px]">
          <thead className="bg-orange-50 text-orange-600">
            <tr>
              <th className="p-3 text-left font-semibold">Test Name</th>
              <th className="p-3 text-center font-semibold">Min Score</th>
              <th className="p-3 text-center font-semibold">
                Min Score <br /> (10-Week ELICOS / Pathway)
              </th>
              <th className="p-3 text-center font-semibold">
                Min Score <br /> (20-Week ELICOS)
              </th>
            </tr>
          </thead>

          <tbody>
            {[
              ["CAE Advance", "169", "142", "142"],
              ["CAE Advance", "6.0", "5.5", "5.5"],
              ["CAE Advance", "Score B", "Score B", "Score B"],
              ["CAE Advance", "169", "142", "142"],
            ].map((row, i) => (
              <tr key={i} className="border-t">
                {row.map((cell, idx) => (
                  <td
                    key={idx}
                    className={`p-3 ${
                      idx === 0 ? "font-semibold" : "text-center"
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="absolute right-[-50px] bottom-[-50px] w-40 h-40 bg-purple-100 rounded-full opacity-40" />
      </div>
      {/* ================= Finance & Expenses ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" />{" "}
          Finance & Expenses{" "}
        </h3>

        <hr className="my-4 border-gray-100" />

        <p className="text-md text-gray-800 leading-relaxed">
          {stripHtml(data.aboutCountry.fwas)}
        </p>
      </div>

      {/* ================= Post Time Work Options ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" /> Post
          Time Work Options
        </h3>

        <hr className="my-4 border-gray-100" />

        <p className="text-md text-gray-800 leading-relaxed">
          {stripHtml(data.aboutCountry.pswo)}
        </p>
      </div>

      {/* ================= Part Time Work Options ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" /> Part
          Time Work Options
        </h3>

        <hr className="my-4 border-gray-100" />

        <p className="text-md text-gray-800 leading-relaxed">
          {stripHtml(data.aboutCountry.ptwo)}
        </p>

        {/* Decorative circle */}
        <div className="absolute right-[-40px] bottom-[-40px] w-40 h-40 bg-orange-100 rounded-full opacity-40" />
      </div>
    </div>
  );
}

/*   Reusable Info ================= */
function Info({ label, value }) {
  return (
    <div>
      <p className="text-gray-400 mb-1">{label}</p>
      <p className="font-semibold text-gray-800">{value}</p>
    </div>
  );
}
